export default [
    {
        text: '使用须知',
        name: 'home',
        path: '/admin/home',
        icon: 'iconfont icon-gaikuangxuanzhong',
        isFold: false
    },
    {
        text: '项目管理',
        name: 'project',
        path: '/admin/project',
        icon: 'iconfont icon-project-o',
        isFold: false
    },{
        text: '卡密管理',
        name: 'card',
        path: '/admin/card',
        icon: 'iconfont icon-cardb',
        isFold: false
    },{
        text: '授权管理',
        name: 'auth',
        path: '/admin/auth',
        icon: 'iconfont icon-kechengshouquan',
        isFold: false
    },
    
   
   
    {
        text: '个人信息',
        name: 'setting-user',
        path: '/admin/setting-user',
        icon: 'iconfont icon-top_gerenxinxi',
        isFold: false
    },
    {
        text: '操作日志',
        name: 'setting-log',
        path: '/admin/setting-log',
        icon: 'iconfont icon-daily-fill',
        isFold: false
    },{
        text: '更换记录',
        name: 'setting-replace',
        path: '/admin/setting-replace',
        icon: 'iconfont icon-jilu',
        isFold: false
    },
    
];
